'use client'
import { useState, useEffect, useRef, memo, useMemo, useCallback } from 'react'
import { Layout } from 'antd'
import { useRouter } from 'next/router'
import Cookies from 'js-cookie'
import { useSelector, useDispatch } from 'react-redux'
import {
  getProfileStatus,
  profileData,
} from '../../../features/auth/apis/authSlice'
import { setDashboardNavbarHeight } from '../../../redux/themeSlice'
import useCompletedProfile from '../../../hooks/useCompletedProfile'
import useTranslation from '../../../hooks/useTranslation'

import HeaderNav from './HeaderNav'
import Sidenav from './Sidenav'
import NavLinks from '../../../features/profile/components/NavLinks'
// import Chat from '../../../features/chat/components/Chat'

const { Header, Sider, Content } = Layout

const DashboardLayout = ({ children }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const ref = useRef(null)
  const { push, asPath, query, events } = useRouter()

  const { page } = query

  const [collapsed, setCollapsed] = useState(false)

  const { profile, error } = useSelector((state) => state.auth)

  const [pageOneCompleted, pageTwoCompleted, pageThreeCompleted] =
    useCompletedProfile()

  useEffect(() => {
    if (
      Cookies.get('SMARTCAF_USER_JWT_TOKEN') &&
      !localStorage.getItem('SMARTCAF-AUTH-USER')
    ) {
      dispatch(profileData())
    }

    if (Cookies.get('SMARTCAF_USER_JWT_TOKEN')) {
      dispatch(getProfileStatus())
    }
  }, [dispatch])

  useEffect(() => {
    if (!Cookies.get('SMARTCAF_USER_JWT_TOKEN')) {
      const redirectUrl = `/?redirection_link=${encodeURIComponent(asPath)}`
      push(redirectUrl)
    }
  }, [push, asPath])

  // SETTING NAVBAR HEIGHT
  useEffect(() => {
    if (ref.current) {
      dispatch(setDashboardNavbarHeight(ref.current.clientHeight))
    }
  })

  useEffect(() => {
    const handleRouteChange = () => {
      const scrollContainer = document.querySelector(
        '.dashboard-layout .ant-layout'
      )
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: 0,
        })
      }
    }

    events.on('routeChangeComplete', handleRouteChange)
    return () => {
      events.off('routeChangeComplete', handleRouteChange)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events])

  /**
   * PROFILE LINKS
   */
  const profileLinks = useMemo(() => {
    return [
      {
        id: 1,
        title: t('Personal Information'),
        completed: pageOneCompleted,
      },
      {
        id: 2,
        title: t('Address'),
        completed: pageTwoCompleted,
      },
      {
        id: 3,
        title: t('Attachments'),
        completed: pageThreeCompleted,
      },
    ]
  }, [t, pageOneCompleted, pageTwoCompleted, pageThreeCompleted])

  const [activeProfileLink, setActiveProfileLink] = useState(profileLinks[0])
  useEffect(() => {
    if (page) {
      const index = page - 1
      setActiveProfileLink(profileLinks[index])
    } else {
      setActiveProfileLink(profileLinks[0])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page])
  const setProfileLink = useCallback((id) => {
    setActiveProfileLink(id)
  }, [])

  const isProfilePage = asPath.includes('profile')

  return (
    <Layout className='dashboard-layout'>
      {/* <Chat /> */}
      <Sider collapsed={collapsed} onCollapse={(value) => setCollapsed(value)}>
        <Sidenav {...{ collapsed }} />
      </Sider>
      <Layout>
        
          <Header
            ref={ref}
            className={`shadow-md ${
              isProfilePage ? '!pb-0' : ''
            } sticky top-0 z-99`}
          >
            <HeaderNav {...{ collapsed, setCollapsed }} />
            {isProfilePage && (
              <NavLinks
                {...{
                  links: profileLinks,
                  activeLink: activeProfileLink,
                  setLink: setProfileLink,
                }}
              />
            )}
          </Header>
          <Content>
            {children}
            <div className='h-[20px] md:h-[100px]'></div>
          </Content>
      </Layout>
    </Layout>
  )
}

export default memo(DashboardLayout)
